// src/firebase/core.js
import { initializeApp } from "firebase/app";
import { 
  getAnalytics, 
  logEvent, 
  isSupported,
  setConsent // Reemplazamos setDebugMode con la API actual
} from "firebase/analytics";

const firebaseConfig = 
{
  apiKey: "AIzaSyAyFmu-fPxPBnIH-BZ9qEIJNVUwzOkWj4U",
  authDomain: "cpositivosdev.firebaseapp.com",
  projectId: "cpositivosdev",
  storageBucket: 'cpositivosdev.firebasestorage.app',
  messagingSenderId: "92573039572",
  appId: "1:92573039572:web:8ebefcc7d24b04d13fb441",
  measurementId: "G-L8FMWHP74N"
};

let app;
let analytics;
let initialized = false;

const initFirebase = async () => 
{
  if (typeof window === "undefined" || initialized) return;

  try {
    app = initializeApp(firebaseConfig);
    const analyticsSupported = await isSupported();
    
    if (analyticsSupported) 
    {
      analytics = getAnalytics(app);
      
      // Configuración de consentimiento
      setConsent({
        analytics_storage: 'granted',
        ad_storage: 'denied'
      });

      if (process.env.NODE_ENV === "development") 
      {
        logEvent(analytics, "debug_mode", {
          debug: true,
          environment: "development"
        });
        console.log("[Firebase] Modo desarrollo activado");
      }
      
      initialized = true;
      console.log("[Firebase] Analytics inicializado correctamente");
    } 
    else 
    {
      console.warn("[Firebase] Analytics no soportado en este entorno");
    }
  } 
  catch (error) 
  {
    console.error("[Firebase] Init error:", error);
  }
};

// Obtener instancia de analytics con inicialización segura
const getAnalyticsInstance = async () => 
{
  if (typeof window === "undefined") return null;
  
  if (!initialized) 
  {
    await initFirebase();
  }
  
  return analytics;
};

// Logger mejorado con inicialización automática
const trackEvent = async (eventName, params = {}) => 
{
  const instance = await getAnalyticsInstance();
  if (instance) {
    logEvent(instance, eventName, {
      ...params,
      environment: process.env.NODE_ENV,
      timestamp: new Date().toISOString()
    });
  }
};

export { 
  initFirebase,
  getAnalyticsInstance as analytics,
  trackEvent as logEvent
};